import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PainScoreDogAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-pain-score-dog-slot',
    templateUrl: './pain-score-dog-slot.component.html',
    styleUrl: './pain-score-dog-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainScoreDogSlotComponent implements SheetSlotComponentBase {

	action!: PainScoreDogAction;
	value!: string | null;

	@Input('action') set updateAction(action: PainScoreDogAction | null) {
		this.action = action as PainScoreDogAction;
		this.value = this.action.totalScore?.toString() ?? null;
	}

	constructor() {
	}
}